import { scrileConnect as ProvidersFactory } from "@scrile/api-provider/dist/";
import Configuration from "@scrile/api-provider/dist/Configuration";
import emitter from "@/lib/emitter";
import config from "@/config";
import AppStorage from "./appStorage";
import { IS_BROWSER } from "./browserUtils";

const providers = ProvidersFactory({
  url: config.apiUrl,
  notificationCB: (event, payload) => {
    emitter.emit(event, payload);
  },
  appStorage: AppStorage,
  websocketOnly: true,
  ...(!IS_BROWSER
    ? {
        fetch: require("node-fetch").default,
        webSocketImpl: require("websocket").w3cwebsocket,
      }
    : {}),
});

Configuration.featureLiveChat = config.featureGoLive;
Configuration.featurePaidMessageAttachments = true;
Configuration.featureFeedPublicReview = config.featureFeedPublicReview;

export default providers.providers;
